import React from 'react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { WA_STATUS, WA_PRIORITY, WA_CATEGORIES, WaBadge } from './waTicketMeta';

function Pick({ label, value, options, onChange, testid }) {
  return (
    <div>
      <label className="text-xs text-[hsl(var(--muted-foreground))]">{label}</label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
        <SelectContent>{options.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}

export function WaTicketControls({ t, canAct, onChange }) {
  const patch = async (fields) => {
    try { await api.patch(`/wa-tickets/${t.id}`, fields); toast.success('Ticket actualizado'); onChange(); } catch (e) { toast.error(errText(e)); }
  };
  if (!canAct) {
    return <div className="flex gap-2"><WaBadge map={WA_STATUS} value={t.status} /><WaBadge map={WA_PRIORITY} value={t.priority} /><Badge variant="outline">{t.category}</Badge></div>;
  }
  return (
    <Card className="p-3 grid grid-cols-1 md:grid-cols-4 gap-3 items-end bg-[hsl(var(--muted))]/20">
      <Pick label="Estado" value={t.status} options={Object.entries(WA_STATUS).map(([k, v]) => [k, v.label])} onChange={(v) => patch({ status: v })} testid="wa-ticket-status" />
      <Pick label="Prioridad" value={t.priority} options={Object.entries(WA_PRIORITY).map(([k, v]) => [k, v.label])} onChange={(v) => patch({ priority: v })} testid="wa-ticket-priority" />
      <Pick label="Categoría" value={t.category} options={WA_CATEGORIES.map((c) => [c, c])} onChange={(v) => patch({ category: v })} testid="wa-ticket-category" />
      <div>
        <label className="text-xs text-[hsl(var(--muted-foreground))]">Agente asignado</label>
        <Input defaultValue={t.assigned_agent} onBlur={(e) => { const v = e.target.value.trim(); if (v !== (t.assigned_agent || '')) patch({ assigned_agent: v }); }} data-testid="wa-ticket-agent" />
      </div>
    </Card>
  );
}
